import React, { useEffect, useState, useMemo } from "react"
import _ from "lodash"
import { useRenderStyling } from 'lib/hooks/useRenderStyling';
import { formatter, getApiFeedData, parseContent, parseContentGroup } from "./utils"
import { useDataCollector, useRulesChecker } from "lib/hooks"


export default function SummaryTableRender({ renderPkg }:{ renderPkg?:any }){

  const { check, checkForSubstitute, hideTheseItems } = useRulesChecker()
  const { prepDataForRender } = useDataCollector()

  const [ collectedData, setCollectedData ] = useState<any[]>([])
  const [ currentElement, setCurrentElement ] = useState<any>(null)
  const [ contentToRender, setContentToRender ] = useState<any>({ labels: [], dataset: [] })

  const outerStyling = useRenderStyling("w-full flex flex-col mt-4", "styleObj")
  const innerStyling = useRenderStyling("w-full flex flex-col justify-start items-start", "styleObj")
  const rowStyling = useRenderStyling("w-full flex items-center pt-0.5 pb-0.5", "styleObj")
  const labelStyling = useRenderStyling("w-44 font-semibold text-right pr-4 text-neutral-900", "styleObj")
  const dataStyling = useRenderStyling("text-neutral-900", "styleObj")

  useEffect(() => {
    if( renderPkg ){
      const elemStructure = renderPkg.elements.find( (elem:any) => elem.refstr === "summary_table" )?.config?.structure || []
      const data = prepDataForRender("summary_table", renderPkg.clientdata, elemStructure, renderPkg, "object")
      setContentToRender(data)
    }
  },[renderPkg])

  useEffect(() => {
    if( !currentElement ) {
      const elem = renderPkg.elements.find( (elem:any) => elem.refstr === "summary_table" )
      if( elem ) setCurrentElement(elem)
    }
  },[renderPkg, currentElement])

  if( !currentElement || !contentToRender ) return <></>
  return (
    <div id="mm-summary-table" {...outerStyling}>
      <div {...innerStyling}>
        { Object.keys(contentToRender).filter( (key:string) => contentToRender[key].okToRender !== false ).map( (key:any) => (
          <div key={key} {...rowStyling}>
            <div {...labelStyling}>{ contentToRender[key].label }</div>
            <div {...dataStyling}>{ contentToRender[key].value }</div>
          </div>
        ))}
      </div>
    </div>
  )
}